import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ZahtjevTable } from '../../common/types/types';

interface ZahtjeviState {
  dohvaceniZahtjevi: ZahtjevTable[];
  updateTable: boolean;
}

const initialState: ZahtjeviState = {
  dohvaceniZahtjevi: [],
  updateTable: false,
};

const zahtjeviSlice = createSlice({
  name: 'zahtjevi',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setDohvaceniZahtjevi: (state, action: PayloadAction<ZahtjevTable[]>) => {
      return { ...state, dohvaceniZahtjevi: action.payload };
    },
    toggleUpdateDocumentsTable(state) {
      state.updateTable = !state.updateTable;
    },
  },
});

export const { reset, setDohvaceniZahtjevi, toggleUpdateDocumentsTable } = zahtjeviSlice.actions;
export default zahtjeviSlice.reducer;
